import { useEffect } from 'react'
import { RELEASE_DATE } from '../constants/overview'

/**
 * Auto-load the latest release: when a new build is out (RELEASE_DATE changed),
 * stamp it and hard-reload once instead of asking the user to click a banner.
 *
 * Known limitation: this runs inside the bundle the browser already loaded, so
 * it only fires after a fresh bundle arrives (one redundant reload) — it cannot
 * force a stale cached bundle to update. A true fix needs a server-side version
 * probe (e.g. fetch('/version.json', { cache: 'no-store' })) compared against
 * the built RELEASE_DATE; centralized here so that swap is a one-file change.
 */
const useReloadOnRelease = () => {
  useEffect(() => {
    if (localStorage.getItem('lastupdated') !== RELEASE_DATE) {
      localStorage.setItem('lastupdated', RELEASE_DATE)
      window.location.reload(true)
    }
  }, [])
}

export default useReloadOnRelease
